import type {
  MergedProposalReviewCandidate,
  WorldProposalReviewSelection,
  WorldProposalStagedVariantRecord,
} from "@/lib/world/review/worldProposalReview.types";

export type PreferredReviewSource = NonNullable<WorldProposalReviewSelection["preferredSource"]>;

export type StagedVariantReviewRecord = WorldProposalStagedVariantRecord;

export type WorldProposalReviewSelectionRecord = WorldProposalReviewSelection;

export type PromotionSelectionInput = {
  reviewSelection?: WorldProposalReviewSelectionRecord;
  stagedVariant?: StagedVariantReviewRecord;
  mergedCandidate?: MergedProposalReviewCandidate;
};

export type PromotionSelectionResult =
  | {
      source: "baseline";
    }
  | {
      source: "staged_variant";
      stagedVariant: StagedVariantReviewRecord;
    }
  | {
      source: "merged";
      mergedCandidate: MergedProposalReviewCandidate;
    };

export function resolvePromotionSelection(
  input: PromotionSelectionInput,
): PromotionSelectionResult {
  const preferred = input.reviewSelection?.preferredSource;

  if (
    preferred === "merged"
    && input.mergedCandidate
    && (!input.reviewSelection?.mergedId || input.reviewSelection.mergedId === input.mergedCandidate.mergedId)
  ) {
    return {
      source: "merged",
      mergedCandidate: input.mergedCandidate,
    };
  }

  if (
    preferred === "staged_variant"
    && input.stagedVariant
    && (!input.reviewSelection?.stagedVariantId || input.reviewSelection.stagedVariantId === input.stagedVariant.variantId)
  ) {
    return {
      source: "staged_variant",
      stagedVariant: input.stagedVariant,
    };
  }

  return {
    source: "baseline",
  };
}